export class HiLowRange
{
    low: number;
    high: number;
}